export default __webpack_public_path__ + "static/media/PasswordRecoveryDraw.f8804e01.svg";